let moment = require('moment')
moment.locale('es')

// Agregar parametro con valor value al array proporcionado: ["param=value"]
// si ya existe, sobrescribir
function agregarUrlParam (array, param, value) {
  let yaAnadido = false

  for (let index = 0; index < array.length; index++) {
    const element = array[index]

    if (element.split('=', 1)[0] === param) {
      yaAnadido = true
      array[index] = param + '=' + value
    }
  }

  if (!yaAnadido) {
    array.push(param + '=' + value)
  }
}

// Saca un parametro del arreglo con el nombre proporcionado
function sacarUrlParam (array, param) {
  for (let index = 0; index < array.length; index++) {
    const element = array[index]

    if (element.split('=', 1)[0] === param) {
      array.splice(index, 1)
    }
  }
}

// Dada una fecha que moment pueda procesar,
// devolver una fecha con formato DD/MM/YYYY
function formatearFecha (fecha) {
  if (fecha === '' || fecha == null) {
    return ''
  }

  return moment(fecha, 'DD-MM-YYYY').format('DD/MM/YYYY')
}

// Dada una fecha que moment pueda procesar,
// devolver una fecha con formato DD/MM/YYYY hh:mm
function formatearFechaHora (fecha) {
  if (fecha === '' || fecha == null) {
    return ''
  }

  return moment(fecha).format('DD/MM/YYYY hh:mm')
}

// Dada una hora de formato hh:mm:ss, devolver hh:mm
function formatearHora (hora) {
  if (hora == null) {
    return
  }
  return hora.substr(0, 5)
}

// Formatear a dinero ARG
function plata (nro) {
  return parseFloat(nro).toLocaleString('es-AR', {
    style: 'currency',
    currency: 'ARS'
  })
}

// A dos decimales
function dosDec (nro) {
  return Math.round(nro * 100) / 100
}
function tablaResp () {
  if (screen.width < 768) {
    return { scrollX: true, whiteSpace: 'nowrap' }
  } else {
    return { scrollX: false, whiteSpace: 'normal' }
  }
}

const colorStatus = {
  pending: '#e6aa12',
  Accepted: '#5289ff',
  'On the Way': '#cc54ff',
  Cancelled: '#ff5454',
  Delivered: '#32ba00'
}

const colorTraduccion = {
  pending: 'Pendiente',
  Accepted: 'Aceptado',
  'On the Way': 'En Camino',
  Cancelled: 'Cancelado',
  Delivered: 'Entregado'
}

const colorReserva = {
  pending: '#e6aa12',
  Accepted: '#5289ff',
  Rejected: '#ff5454'
}

const colorReservaTraduccion = {
  pending: 'Pendiente',
  Accepted: 'Aceptado',
  Rejected: 'Rechazado'
}

const diaTraduccion = {
  Monday: 'Lunes',
  Tuesday: 'Martes',
  Wednesday: 'Miércoles',
  Thursday: 'Jueves',
  Friday: 'Viernes',
  Saturday: 'Sabado',
  Sunday: 'Domingo'
}

const estadosPedido = [
  { key: 'pending', label: 'Pendiente' },
  { key: 'Accepted', label: 'Aceptado' },
  { key: 'On the Way', label: 'En Camino' },
  { key: 'Cancelled', label: 'Cancelado' },
  { key: 'Delivered', label: 'Entregado' }
]

const estadosReserva = [
  { key: 'Accepted', label: 'Aceptado' },
  { key: 'Rejected', label: 'Rechazado' }
]

// Convertir BASE64 a File
async function urltoFile (url, filename, mimeType) {
  return fetch(url)
    .then(function (res) {
      return res.arrayBuffer()
    })
    .then(function (buf) {
      return new File([buf], filename, { type: mimeType })
    })
}
// Extraer Mime Type de un BASE64
function base64MimeType (encoded) {
  var result = null

  if (typeof encoded !== 'string') {
    return result
  }

  var mime = encoded.match(/data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*/)

  if (mime && mime.length) {
    result = mime[1]
  }

  return result
}

export default {
  agregarUrlParam,
  sacarUrlParam,
  formatearFecha,
  formatearFechaHora,
  formatearHora,
  plata,
  colorStatus,
  colorTraduccion,
  estadosPedido,
  dosDec,
  tablaResp,
  diaTraduccion,
  estadosReserva,
  colorReserva,
  colorReservaTraduccion,
  urltoFile,
  base64MimeType
}



// WEBPACK FOOTER //
// ./src/utils/common.js